export const BASE_URL = "https://plattform.schorn-muendung.de/api";
export const LOGIN_ENDPOINT = "/auth/login";
